/**
 * Created by roi on 2/05/17.
 */
import { OBSERVACIO_PERIODE_SELECCIONAT,
    OBSERVACIO_INICIALITZAR } from '../../actions/actionTypes';
import { PERIODE_MATI } from '../../constants';

const ESTAT_INICIAL_PERIODE_SELECCIONAT = PERIODE_MATI[0];

const periodeSeleccionat = (state = ESTAT_INICIAL_PERIODE_SELECCIONAT, action) => {

    switch (action.type) {
        case OBSERVACIO_PERIODE_SELECCIONAT:
            return action.periodeSeleccionat;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_PERIODE_SELECCIONAT;
        default:
            return state;
    }
};

export default periodeSeleccionat;



// WEBPACK FOOTER //
// ./src/reducers/observacio/periodeSeleccionat.js